import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Mic, UserPlus, HandCoins, CalendarPlus, Camera, Sparkles, AudioLines } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetDescription } from "@/components/ui/sheet";

const ACTIONS = [
  { id: "voice-journal", label: "Record Voice Journal", desc: "Talk through your day · AI extracts the rest", icon: AudioLines, to: "/ai-extract?tab=voice-journal" },
  { id: "meeting", label: "Add Meeting Update", desc: "Paste a NeoSapien summary", icon: Mic, to: "/ai-extract?tab=meeting" },
  { id: "vcard", label: "Upload Visiting Card", desc: "AI extracts contact details", icon: Camera, to: "/ai-extract?tab=vcard" },
  { id: "deal", label: "Add Deal", desc: "New opportunity", icon: HandCoins, to: "/deals?new=1" },
  { id: "contact", label: "Add Contact", desc: "Manual entry", icon: UserPlus, to: "/clients?newContact=1" },
  { id: "followup", label: "Add Follow-up", desc: "Schedule next action", icon: CalendarPlus, to: "/followups?new=1" },
];

export default function FAB() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="fab-button"
        aria-label="Quick actions"
        className="fixed bottom-20 right-5 lg:bottom-8 lg:right-8 z-30 h-14 w-14 rounded-full bg-primary text-primary-foreground grid place-items-center shadow-fab tap hover:scale-105 transition"
        style={{ marginBottom: "env(safe-area-inset-bottom)" }}
      >
        <Plus className="h-6 w-6" strokeWidth={2.5} />
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent
          side="bottom"
          className="rounded-t-[28px] border-t-0 px-5 pb-8 pt-3 max-h-[80vh] overflow-y-auto"
          data-testid="fab-sheet"
          aria-describedby="fab-sheet-desc"
        >
          <SheetTitle className="sr-only">Quick capture</SheetTitle>
          <SheetDescription id="fab-sheet-desc" className="sr-only">
            Pick a quick action to capture sales memory.
          </SheetDescription>
          <div className="mx-auto h-1.5 w-12 rounded-full bg-muted-foreground/20 mb-4" />
          <div className="px-1 mb-4">
            <p className="text-[10px] uppercase tracking-[0.18em] font-bold text-muted-foreground flex items-center gap-1.5">
              <Sparkles className="h-3 w-3" /> Quick capture
            </p>
            <h3 className="font-display text-2xl font-extrabold tracking-tight mt-1">What just happened?</h3>
          </div>
          <div className="space-y-2">
            {ACTIONS.map((a) => (
              <button
                key={a.id}
                onClick={() => {
                  setOpen(false);
                  navigate(a.to);
                }}
                data-testid={`fab-action-${a.id}`}
                className="w-full flex items-center gap-4 p-4 rounded-2xl border border-border/60 bg-card hover:bg-muted/50 transition tap text-left card-lift"
              >
                <div className="h-11 w-11 rounded-2xl bg-primary-50 text-primary-700 grid place-items-center">
                  <a.icon className="h-5 w-5" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-sm leading-tight">{a.label}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">{a.desc}</p>
                </div>
              </button>
            ))}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
